import { Binoculars } from '@phosphor-icons/react';

export default Binoculars;
